import ReactMarkdown from 'react-markdown';
import patchData from '../app/patchnotes/patch-notes.json';

interface Item {
    summary: string;
    details: string;
}

interface Category {
    name: string;
    items: Item[];
}

interface Section {
    title: string;
    categories: Category[];
}

interface PatchNote {
    version: string;
    date: string;
    sections: Section[];
}

interface PatchData {
    patchNotes: PatchNote[];
}

const PatchNotes = () => {
    const data = patchData as PatchData;

    return (
        <div className="container mx-auto px-4 py-8">
            <h1 className="text-3xl font-bold mb-8">Patch Notes</h1>
            <div className="space-y-12">
                {data.patchNotes.map((patch, patchIndex) => (
                    <div key={patchIndex} className="card bg-base-200 shadow-lg p-6">
                        <div className="card-body p-0">
                            <h2 className="card-title text-2xl mb-2">Version {patch.version}</h2>
                            <p className="text-base-content/70 mb-6">{new Date(patch.date).toLocaleDateString('sv-SE', { year: 'numeric', month: 'numeric', day: 'numeric' })}</p>
                            
                            <div className="space-y-6">
                                {patch.sections.map((section, sectionIndex) => (
                                    <div key={sectionIndex}>
                                        <h3 className="text-xl font-medium mb-4 border-b border-base-content/20 pb-2">{section.title}</h3>
                                        <div className="space-y-4">
                                            {section.categories.map((category, catIndex) => (
                                                <div key={catIndex} className="ml-4">
                                                    <h4 className="text-lg font-normal text-primary mb-3">{category.name}</h4>
                                                    <ul className="list-disc space-y-2 pl-5">
                                                        {category.items.map((item, itemIndex) => (
                                                            <li key={itemIndex}>
                                                                <strong className="font-semibold">{item.summary}: </strong>

                                                                <div className="prose prose-sm dark:prose-invert max-w-none inline">
                                                                    <ReactMarkdown components={{ p: 'span' }}>{item.details}</ReactMarkdown>
                                                                </div>
                                                            </li>
                                                        ))}
                                                    </ul>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default PatchNotes;